import { Appearance } from '@/types';
import { getHasScreenPrintingPrintType } from '@/model/printType/getHasScreenPrintingPrintType';
import { getPrintTypesOfAppearance } from './getPrintTypesOfAppearance';

export function getIsScreenPrintingAppearance(appearance: Appearance) {
  return getHasScreenPrintingPrintType(getPrintTypesOfAppearance(appearance));
}
